import { render } from "./CategoryForm.vue?vue&type=template&id=7534bbfa&scoped=true&ts=true"
import script from "./CategoryForm.vue?vue&type=script&lang=ts"
export * from "./CategoryForm.vue?vue&type=script&lang=ts"

import "./CategoryForm.vue?vue&type=style&index=0&id=7534bbfa&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7534bbfa"]])

export default __exports__